import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  ScrollView,
  useWindowDimensions,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { checkOut, fetchBillDetailsWithRetry, guestBillDetails, guestHistory, sendGuestMail } from '../../Redux/Actions/viewBillAction';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../utils/Helper';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import CustomFlatList from '../../components/customFlatList';
import InfoPopupModal from '../../components/infoPopupModal';
import { setGoBackTab, setGoHome, setInitAppLogout, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { formatDate } from '../../js/formatDate';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { useFocusEffect } from '@react-navigation/native';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { CHECK_OUT_FAILED, CHECK_OUT_SUCCESS, CLICKED, EXIT, INITIAL_LOADER_SCREEN, MY_BILL_CATEGORY } from '../../config/Constant';
import { CHECK_CIRCLE } from '../../assets';
import Header from '../../components/Header/Header';
import RenderHTML from 'react-native-render-html';



const MyBill_Landscape = ({ isTabScreen, navigation }) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const { width } = useWindowDimensions();

  const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
  const [myBillSessionToken, setmyBillSessionToken] = useState(() => generateToken("mybill_"));
  const [modalState, setModalState] = useState({
    isInfoModalVisible: false,
    checkoutStatus: '',
    title: t('viewBill.checkout'),
    subTitle: t('viewBill.are_you_sure'),
    onClose: ()=>{},
    onContinue: ()=>{}
  })

  const [loadingState, setLoadingState] = useState({
    loading: false,
    loaderMessage: ''
  })
  const [initialLoading, setInitialLoading] = useState(false);

  const [checkoutConfirmVisible, setCheckoutConfirmVisible] = useState(false);


  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;

  const { isLoggedIn, loggedInRoomNumber } = useSelector((state) => state.appConfigSlice);
  const { guestBillDetailsData, error } = useSelector(
    state => state.guestBillDetailsSlice,
  );

  const { currentGuestDetails } = useSelector(
    state => state.guestDetailsSlice,
  );

  const { currentWidget, extraConfigParam } = useSelector(
    state => state.deviceConfigSlice,
  );
  const dateFormat = extraConfigParam?.DATE_FORMAT;


  let reservationNumber = currentGuestDetails?.reservationNumber
  let locationId = currentGuestDetails?.location
  let arrival = currentGuestDetails?.checkInDate
  let checkout = currentGuestDetails?.plannedCheckOutDate
  let balanceAmount = guestBillDetailsData?.payload?.billTotal?.balanceAmount
  let billItems = guestBillDetailsData?.payload?.rawBill?.billItems
  let billTotal = guestBillDetailsData?.payload?.billTotalStr

  let expressCheckoutIntervalTime = extraConfigParam?.EXPRESS_CHECKOUT_TIME_INTERVALS
  // let expressCheckoutIntervalTime = ''

  let guestBillIntervalTime = expressCheckoutIntervalTime?.split(",")[2]

  const fetchData = async () => {
    setInitialLoading(true)
    handleCheckoutConfirmVisibility(false)
    try {
      const {status, response} = await dispatch(guestHistory(reservationNumber, locationId, guestBillIntervalTime));
      if(!status){
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'retry',
          title: null,
          subTitle: response,
          onClose: handleGoBack,
          onContinue: retryBillDetails
        }))
      }
    } catch (error) {
    } finally {
      setInitialLoading(false)
    }
  };

  const retryBillDetails = async () => {
    setInitialLoading(true);
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false,
    }))
    try{
      const response = await dispatch(fetchBillDetailsWithRetry(reservationNumber, locationId));
      
    }catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'retry',
        title: null,
        subTitle: error,
        onClose: handleGoBack,
        onContinue: retryBillDetails
      }))
    }finally {
      setInitialLoading(false)
    }
  }


  useFocusEffect(useCallback(() => {
    dispatch(sendAnalytics(MY_BILL_CATEGORY, CLICKED, { element: "widget", widgetSessionId: myBillSessionToken }))

    return () => {
      const widgetCloseTime = new Date;
      const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
      dispatch(sendAnalytics(MY_BILL_CATEGORY, EXIT, { element: "widget", "duration": widgetCloseDuration, widgetSessionId: myBillSessionToken }))
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []))

  const handleCheckoutConfirmVisibility = (visible = !checkoutConfirmVisible) => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false
    }))
    setCheckoutConfirmVisible(visible)
  };

  const handleCheckoutPress = async () => {
    await dispatch(sendGuestMail(currentGuestDetails?.guestProfile?.email, locationId))
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: true
    }))
  };

  const onSuccess = async (msg) => {
    try{
      const response = await dispatch(guestBillDetails(reservationNumber, locationId));

      if(response?.payload?.XC?.Status == "SUCCESS"){
        setModalState(prev => ({
          ...prev,
          title: t('viewBill.successfully_checked_out'),
          isInfoModalVisible: true,
          checkoutStatus: 'success',
          onClose: null,
          onContinue: onSuccessLogout
        }))
        setCheckoutConfirmVisible(false)
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - SUCCESS", {element: "widget", widgetSessionId: myBillSessionToken }))

      } else if(response?.payload?.XC?.Status == "FAILED"){
        onFailure(response?.payload?.XC?.Message);
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": response?.payload?.XC?.Message }))
      } else {
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'retry',
          title: t('viewBill.checkoutFailed'),
          subTitle: t('viewBill.checkoutFailedMsg'),
          onClose: handleGoBack,
          onContinue: () => {handleInfoModalClose(); fetchData()}
        }))
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": response?.header?.status?.msg }))
      }
      
      
    } catch (err){
      console.log("Guest History: ", err);

      onFailure(err?.message)
      
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": err?.message }))
    } finally {
      setLoadingState({
        loading: false,
        loaderMessage: null
      })
    }
  }
  const onFailure = (msg) => {
    let errMessage = msg || t('viewBill.checkoutFailedMsg')
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: true,
      checkoutStatus: 'retry',
      title: t('viewBill.checkoutFailed'),
      subTitle: errMessage || t('viewBill.checkoutFailedMsg'),
      onClose: handleGoBack,
      onContinue: () => {handleInfoModalClose(); fetchData()}
    }))
    setLoadingState({
      loading: false,
      loaderMessage: null
    })

    dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": errMessage }))
  }

  const handleContinue = async () => {
    setLoadingState({
      loading: true,
      loaderMessage: t('viewBill.checkingOut')
    })
    try {
      await dispatch(checkOut(currentGuestDetails, billTotal, onSuccess, onFailure));

    } catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: false
      }))
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": error }))
    } finally {
      
    }
  };

  const handleGoBack = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false
    }))
    if(isTabScreen){
      dispatch(setGoBackTab(true));
    } else {
      handleCloseModal()
    }
  }

  const onSuccessLogout = () => {
    dispatch(setInitAppLogout(true));
  }
  

  const handleInfoModalClose = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false,
      checkoutStatus: undefined,
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleCheckoutConfirmVisibility
    }))
  };

  const handleCloseModal = () => {
    // setShowTryAgainModal(false);
    dispatch(setGoHome(true));
  };

  useFocusEffect(useCallback(() => {
    if (!isLoggedIn) {
      dispatch(setShowLoginModal(true))
      handleCloseModal();
      return;
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []))

  useEffect(()=>{
    setModalState({
      isInfoModalVisible: false,
      checkoutStatus: '',
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleCheckoutConfirmVisibility
    })
    if(!expressCheckoutIntervalTime){
      setLoadingState(prev => ({
        ...prev,
        loading: false
      }))
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'error',
        title: t("viewBill.express_checkout_interval_time_err_title"),
        subTitle: t("viewBill.express_checkout_interval_time_err"),
        onClose: null,
        onContinue: handleGoBack
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expressCheckoutIntervalTime, t])

  const customGuestRequestTitleStyle = getStyles([
    'widgetmainContainerHeaderTitle',
    'billHeaderTitle_landscape'
  ]);

  return (
    <View id='widgetRootContainer' style={getStyles(['widgetRootContainer'])}>
      {isTabScreen ? <Header /> : <HeaderWithBack handleCustomBackPress={checkoutConfirmVisible ? () => handleCheckoutConfirmVisibility(false) : undefined} />}

      {loadingState.loading &&  <FetchingDataScreen loaderMessage={loadingState.loaderMessage}/>}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN || "FETCHING_LOADER")}
      {!(loadingState.loading || initialLoading) ?
      <>
        <ScrollView id='widgetmainContainer viewbillMainContainer_landscape' contentContainerStyle={getStyles(['widgetmainContainer', 'viewbillMainContainer_landscape'])} showsVerticalScrollIndicator={false} >
          {checkoutConfirmVisible ? 
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'viewBillConfirmCheckoutHeaderContainer_landscape'])}>
              <ImageComp source={CHECK_CIRCLE} style={getStyles(['widgetmainContainerHeaderImg', 'viewBillConfirmCheckoutMainContainerHeaderImg_landscape'])} />
  
              <View style={[getStyles(['widgetmainContainerHeaderTitleContainer', 'viewBillConfirmCheckoutMainContainerHeaderTitleContainer_landscape'])]}>
                  <Text style={getStyles(['widgetmainContainerHeaderTitle', 'viewBillConfirmCheckoutMainContainerHeaderTitle_landscape'])}>{t("viewBill.checkout_confirm_header")}</Text>
                  <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'viewBillConfirmCheckoutMainContainerHeaderSubTitle_landscape'])}>{t("viewBill.checkout_confirm_subheader")}</Text>
              </View>
            </View>
          : isLoggedIn && <>
            {expressCheckoutIntervalTime && <View style={getStyles(["", {paddingHorizontal: 30}])}>
                <ImageComp  id='widgetmainContainerHeaderImg ViewBillWidgetHeaderImg_landscape' source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'ViewBillWidgetHeaderImg_landscape'])} />
                  <View id='billContainer' style={getStyles(['billContainer'])}>
                    <RenderHTML
                      contentWidth={width}
                      baseStyle={customGuestRequestTitleStyle}
                      source={{html: t('viewBill.heading')}}
                      systemFonts={ Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? customGuestRequestTitleStyle.fontFamilyArr : [customGuestRequestTitleStyle.fontFamily]}
                      numberOfLines={2}
                      id={`widgetmainContainerHeaderTitle billHeaderTitle_landscape`}
                    />
                    <Text style={getStyles(["billHeaderSubTitle_landscape"])}>{t('viewBill.sub_heading')}</Text>

                    

                    {(arrival && checkout) ? 
                      <View style={getStyles(['viewBillDateContainer_landscape'])} id='viewBillDateContainer_landscape'>
                        <View style={getStyles(["viewBillDateItemContainer_landscape"])} id='viewBillDateItemContainer_landscape'>
                          <Text id='viewBillDateItemTitle_landscape' style={getStyles(['viewBillDateItemTitle_landscape'])}>{t("viewBill.arrival")}</Text>
                          <Text id='viewBillDateItemSubTitle viewBillDateItemDurationSubTitle_landscape' style={getStyles(['viewBillDateItemSubTitle', "viewBillDateItemDurationSubTitle_landscape"])}>
                            {formatDate(arrival.split("T")[0], dateFormat)}
                          </Text>
                        </View>
      
                        <View style={getStyles(["viewBillDateItemContainer_landscape", "viewBillDateItemContainer_duration_landscape"])} id='viewBillDateItemContainer_landscape viewBillDateItemContainer_duration_landscape'>
                          <Text id='viewBillDateItemTitle_landscape' style={getStyles(['viewBillDateItemTitle_landscape'])}>Duration</Text>
                          <Text id='viewBillDateItemSubTitle viewBillDateItemDurationSubTitle_landscape' style={getStyles(['viewBillDateItemSubTitle', "viewBillDateItemDurationSubTitle_landscape"])}>
                            {(() => {
                              const start = new Date(arrival);
                              const end = new Date(checkout);
      
                              start.setHours(0, 0, 0, 0);
                              end.setHours(0, 0, 0, 0);
      
                              const diffTime = end - start;
                              const nights = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);
                              return `${nights} Night${nights !== 1 ? 's' : ''}`;
                            })()}
                            </Text>
                        </View>
                        
                        <View style={getStyles(["viewBillDateItemContainer_landscape"])} id='viewBillDateItemContainer_landscape'>
                          <Text id='viewBillDateItemTitle_landscape' style={getStyles(['viewBillDateItemTitle_landscape'])}>{t("viewBill.departure")}</Text>
                          <Text id='viewBillDateItemSubTitle viewBillDateItemDurationSubTitle_landscape' style={getStyles(['viewBillDateItemSubTitle', "viewBillDateItemDurationSubTitle_landscape"])}>
                            {formatDate(checkout.split("T")[0], dateFormat)}
                          </Text>
                        </View>
                      </View> 
                      : null
                    }



                    <View id='historyContainer_landscape' style={getStyles(['historyContainer_landscape'])}>
                      <Text id='purcharseBillText_landscape' style={getStyles(['purcharseBillText_landscape'])}>{t('viewBill.purchase_history')}</Text>
                      <Text id='reviewBill_landscape' style={getStyles(['reviewBill_landscape'])}>{t('viewBill.review_bill')}</Text>
                    </View>
                  </View>
              </View>}
            <CustomFlatList
                viewPortHeight={true}
                showsVerticalScrollIndicator={false}
                data={billItems}
                keyExtractor={(item, index) => index.toString()}
                renderItem={({ item }) => (
                <View id='list_itemContainer viewBill_Item_textContainer_landscape' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer_landscape'])}>
                    <View 
                      id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_landscape' 
                      style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_landscape'])}
                    >
                      {item?.itemDesc && 
                        <Text 
                          id='list_itemContainer_textContainer_title ViewBill_itemContainer_textContainer_title_landscape' 
                          style={getStyles(['list_itemContainer_textContainer_title', 'ViewBill_itemContainer_textContainer_title_landscape'])}
                        >
                          {item?.itemDesc}
                        </Text>}
                    </View>

                    <View 
                      id='list_itemContainer_arrow ViewBillWidgetChildContainer_itemContainer_arrow_landscape' 
                      style={getStyles(['list_itemContainer_arrow', 'ViewBillWidgetChildContainer_itemContainer_arrow_landscape'])}
                    >

                      {item?.itemAmount && 
                        <Text 
                          id='list_itemContainer_textContainer_subtitle ViewBill_itemContainer_textContainer_subtitle_landscape' 
                          style={getStyles(['list_itemContainer_textContainer_subtitle', 'ViewBill_itemContainer_textContainer_subtitle_landscape'])} 
                          numberOfLines={1} 
                          >
                            {currencyCode} {item?.itemAmount}
                        </Text>}

                    </View>
                </View>

                )}
                ListEmptyComponent={ expressCheckoutIntervalTime &&
                <View id='list_itemContainer viewBill_Item_textContainer' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer_landscape'])}>
                    <View id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_noHistory_container_landscape' style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_noHistory_container_landscape'])}>
                    <Text id='list_itemContainer_textContainer_noHistory ViewBill_itemContainer_textContainer_noHistory_landscape' style={getStyles(['list_itemContainer_textContainer_noHistory', 'ViewBill_itemContainer_textContainer_noHistory_landscape'])}>
                    {t("viewBill.no_history_present")}
                    </Text>
                    </View>
                </View>
                }
                contentContainerStyle={getStyles(["viewBill_Item_textContentContainer_landscape"])}
                style={getStyles(["viewBill_Item_content_landscape"])}
                id="viewBill_Item_textContentContainer_landscape"
            />
                {<View style={getStyles(["billTotalcontainer_landscape"])} id='billTotalcontainer_landscape'>
                    <Text id='total_landscape' style={getStyles(['total_landscape'])}>{t('viewBill.total')}</Text>
                    <Text id='amount_landscape' style={getStyles(['amount_landscape'])}>{currencyCode} {balanceAmount ? balanceAmount : 0}</Text>
                </View>}
            </>}
        </ScrollView>

        <View id='billCheckoutBtnContainer_landscape' style={getStyles(['billCheckoutBtnContainer_landscape'])}>
          <CustomPressable id='primaryBtn viewBillPrimaryBtn_landscape' onPress={() => checkoutConfirmVisible ? handleContinue() : handleCheckoutPress()} style={getStyles(['primaryBtn', "viewBillPrimaryBtn_landscape"])} disabled={!expressCheckoutIntervalTime}>
            <Text id='primaryBtnTxt' style={getStyles(['primaryBtnTxt'])}>
              {checkoutConfirmVisible ? t('viewBill.confirm_checkout') : t('viewBill.checkout')}
            </Text>
          </CustomPressable>

          <CustomPressable id='secondaryBtn viewBillSecondaryBtn_landscape' onPress={checkoutConfirmVisible ? () => handleCheckoutConfirmVisibility(false) : undefined} style={getStyles(['secondaryBtn', 'viewBillSecondaryBtn_landscape'])} disabled={!expressCheckoutIntervalTime}>
            <Text id='secondaryBtnTxt viewBillSecondaryBtnTxt_landscape' style={getStyles(['secondaryBtnTxt', "viewBillSecondaryBtnTxt_landscape"])}>
              {t('viewBill.back')}
            </Text>
          </CustomPressable>
        </View>
      </> : null}


      {modalState.isInfoModalVisible && !loadingState.loading && 
      <InfoPopupModal
        type={modalState.checkoutStatus}
        title={modalState.checkoutStatus != 'loading' ? modalState.title : null}
        subtitle={modalState.checkoutStatus !== 'loading' && modalState.checkoutStatus !== 'success' ?  modalState.subTitle : null}
        onClose={modalState.onClose}
        OnRequestClose={modalState.onClose}
        onContinue={modalState.onContinue}
        isVisible={modalState.isInfoModalVisible}
        primaryBtnLabel={modalState.checkoutStatus == 'error' ? t('viewBill.on_error_primray_button_title') : modalState.checkoutStatus == 'retry' ? t('viewBill.retry') : null}
      >
        {!modalState.checkoutStatus && <View id='viewBill_infoModalRowView_landscape' style={getStyles(['viewBill_infoModalRowView_landscape'])} >
          <View>
            <Text id='viewBill_infoModalSubheader_landscape' style={getStyles(['viewBill_infoModalSubheader_landscape'])}>{t('viewBill.total')}</Text>
            <Text id='viewBill_infoModalTitle_landscape' style={getStyles(['viewBill_infoModalTitle_landscape'])}>{currencyCode} {billTotal ? billTotal : 0}</Text>
          </View>
          <View >
            <Text id='viewBill_infoModalSubheader_landscape' style={getStyles(['viewBill_infoModalSubheader_landscape'])}>
              {t('viewBill.room')}
            </Text>
            <Text id='viewBill_infoModalTitle_landscape' style={getStyles(['viewBill_infoModalTitle_landscape'])}>
              {loggedInRoomNumber || 'N/A'}
            </Text>
          </View>
        </View>}

      </InfoPopupModal>}
    </View>
  );
};


export default MyBill_Landscape;
